import Icon from '../components/Icon.vue'

Icon.register({
  'long-arrow-alt-down': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M168 345.9V44C168 37.4 162.6 32 156 32H100C93.4 32 88 37.4 88 44V345.9H41.9C20.6 345.9 9.9 371.8 25 386.9L111 473C120.4 482.3 135.6 482.3 145 473L231 386.9C246.1 371.8 235.4 345.9 214.1 345.9H168z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-alt-down.js
// module id = KOuU
// module chunks = 144